import { Dialog, Transition } from '@headlessui/react';
import React, { Fragment } from 'react';

const Modal = (props: {
  cancelButtonRef: React.MutableRefObject<null>;
  isShowModal: boolean;
  closeModalBackground: () => void;
  children: React.ReactNode;
}) => {
  return (
    <Transition.Root show={props.isShowModal} as={Fragment}>
      <Dialog
        as="div"
        static
        className="fixed z-9999 inset-0 overflow-y-auto"
        initialFocus={props.cancelButtonRef}
        open={props.isShowModal}
        onClose={props.closeModalBackground}>
        <div className="flex items-center justify-center min-h-screen px-2 text-center sm:block sm:p-0">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0">
            <Dialog.Overlay className="fixed inset-0 bg-gray-gray700 bg-opacity-75 transition-opacity" />
          </Transition.Child>
          <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
            &#8203;
          </span>
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            enterTo="opacity-100 translate-y-0 sm:scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 translate-y-0 sm:scale-100"
            leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <div className="inline-block align-bottom bg-white rounded-xl overflow-hidden shadow-xl transform transition-all sm:align-middle laptop:w-1/4 tablet:w-3/5 mobile:w-full px-4 pt-8 pb-4">
              {props.children}
            </div>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition.Root>
  );
};

export default Modal;
